import * as Yup from 'yup';
import { showWarningToast } from '../../../utils/toastHelper';

import i18next from 'i18next';

export const t = (key) => i18next.t(key, { ns: 'Customer' });

export const FBZCustomerGroupSchema = Yup.object().shape({
  name: Yup.string().required('CUSTOMER_GROUP_FULL_NAME_REQUIRED'),
  group: Yup.string().required('CUSTOMER_GROUP_NAME_REQUIRED'),
  customer_category: Yup.object()
    .shape({
      id: Yup.string().required('CATEGORY_ID_REQUIRED'),
      name: Yup.string().required('CATEGORY_NAME_REQUIRED'),
    })
    .nullable()
    .required('CUSTOMER_CATEGORY_REQUIRED'),
});

export const CateringCustomerGroupSchema = Yup.object().shape({
  group: Yup.string().required('CUSTOMER_GROUP_NAME_REQUIRED'),
  customer_category: Yup.object()
    .shape({
      id: Yup.string().required('CATEGORY_ID_REQUIRED'),
      name: Yup.string().required('CATEGORY_NAME_REQUIRED'),
    })
    .nullable()
    .required('CUSTOMER_CATEGORY_REQUIRED'),
});
export const validateFBZCustomerGroup = async (data) => {
  try {
    await FBZCustomerGroupSchema.validate(data, { abortEarly: false });
    return true;
  } catch (error) {
    //error.inner.forEach((err) => {
    //     showWarningToast(err.message);
    //    });
    if (Array.isArray(error.inner) && error.inner.length > 0) {
      const firstError = error.inner[0];
      if (firstError.message) {
        showWarningToast(t(firstError.message)); // Show the first message
      }
    }

    return false;
  }
};
export const validateCateringCustomerGroup = async (data) => {
  try {
    await CateringCustomerGroupSchema.validate(data, { abortEarly: false });
    return true;
  } catch (error) {
    //error.inner.forEach((err) => {
    //     showWarningToast(err.message);
    //    });
    if (Array.isArray(error.inner) && error.inner.length > 0) {
      const firstError = error.inner[0];
      if (firstError.message) {
        showWarningToast(firstError.message); // Show the first message
      }
    }

    return false;
  }
};
